export enum FontWeights {
  'HAIRLINE' = 'hairline',
  'THIN' = 'thin',
  'LIGHT' = 'light',
  'NORMAL' = 'normal',
  'REGULAR' = 'regular',
  'MEDIUM' = 'medium',
  'SEMIBOLD' = 'semibold',
  'BOLD' = 'bold',
  'EXTRABOLD' = 'extrabold',
  'BLACK' = 'black',
  'H1' = 'h1',
  'H2' = 'h2',
  'H3' = 'h3',
  'H4' = 'h4',
  'H5' = 'h5',
  'H6' = 'h6',
  'DIVIDER' = 'divider',
  'UI' = 'ui',
  'BODY' = 'body',
  'LINK' = 'link',
}
